const HomeIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill='currentColor'
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
      />
    </svg>
  )
}

export default HomeIcon
